import { defineXray } from "../src/xray/manifest.js";
import { SHELL_TOOL_NAMES } from "../src/mine/shell.js";
import { extractTransferOps, describeMissing } from "../extractors/transfer/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/transfer/spec.js";

export default defineXray({
  id: "transfer",
  label: "Transfers",
  title: "Data an agent moved between this machine and remote storage — which prefix, which direction, and whether anything actually moved",

  consumer: "someone reviewing what left a machine and what was pulled onto it",
  decision: "whether an agent published data somewhere durable and readable by others, or only read from it",

  // MEASURED AS FORMATTING. an s3 cp already says which direction it moved data; grouping prefixes across sessions is a tally, not a finding
  tab: false,
  tabReason: "an s3 cp already says which direction it moved data; grouping prefixes across sessions is a tally, not a finding",
  // Trace-only, so this does not down-select a tab of its own — it is how the
  // LINEAGE window finds the prompts carrying this lens's work. Same matcher
  // its tab-bearing siblings use: every op here is read off a shell command.
  substrate: { label: "shell (bulk transfers)", match: (n) => SHELL_TOOL_NAMES.test(String(n).split("__").pop()) },

  feed: { domain: "transfer" },
  extract: extractTransferOps, collect, group: build, groupBy, anchor, ignore,
  // The remote PREFIX, ids and variables already placeheld by the extractor.
  // Direction decides the role: data leaving the machine outlives the session and
  // is readable by other people, which a download is not.
  lineage: {
    kind: "transfer",
    // A remote location (`s3://bucket/prefix`) — an address, not a name.
    citable: true,
    ref: (op) => op.location || null,
    role: (op) => (op.kind === "upload" || op.kind === "delete" ? "production" : "consultation"),
    text: (op) => op.output || "",
    label: (op) => `${op.kind} ${op.location || "an unnamed location"}`,
    intent: (op) => op.local || null,
  },

  emptyNote: "No transfers work in this window",
  explainMissing: describeMissing,
});
